// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js";

//Service
import breederService from "@/app/services/main/breeder/breeder-service.js";

// Constants
import { STATUS_CODES, STATES, BREEDER_STATUS, BREEDER_STATUS_LIST } from "@/app/constants/constants";

export default {
    name: "BreedersContainer",
    mixins: [tableMixins, toastMessageMixins],
    data() {
        const verificationStatusList = [
            { id: true, name: "VERIFIED" },
            { id: false, name: "UNVERIFIED" },
        ];
        const stateList = [
            {
                id: "NSW",
                name: "New South Wales",
            },
            {
                id: "VIC",
                name: "Victoria",
            },
            {
                id: "QLD",
                name: "Queensland",
            },
            {
                id: "WA",
                name: "Western Australia",
            },
            {
                id: "SA",
                name: "South Australia",
            },
            {
                id: "TAS",
                name: "Tasmania",
            },
            {
                id: "NT",
                name: "Northern Territory",
            },
            {
                id: "ACT",
                name: "Australian Capital Territory",
            },
        ];
        return {
            isAPILoading: false,
            theads: [
                {
                    name: "Company Name",
                    searchLabel: "f_companyName",
                    sortLabel: "companyName",
                    isDesc: false,
                    hasSearch: true,
                    style: null,
                },
                // { name: "Image", searchLabel: null, searchLabel: null, isDesc: false, hasSearch: false, style: null },
                { 
                    name: "Name", 
                    searchLabel: "f_name", 
                    sortLabel: "name", 
                    isDesc: true, 
                    hasSearch: true, 
                    style: 'width: 240px' 
                },
                {
                    name: "Mobile No.",
                    searchLabel: "f_mobileNumber",
                    sortLabel: "mobileNumber",
                    isDesc: false,
                    hasSearch: true,
                    style: null,
                },
                {
                    name: "State",
                    searchLabel: "f_state",
                    sortLabel: "state",
                    isDesc: false,
                    hasDropdown: true,
                    style: "width: 150px;",
                    options: stateList,
                },
                {
                    name: "Verification",
                    searchLabel: "f_verified",
                    sortLabel: "verified",
                    isDesc: false,
                    hasDropdown: true,
                    style: "width: 200px;",
                    options: verificationStatusList,
                },
                {
                    name: "Status",
                    searchLabel: "f_status",
                    sortLabel: "status",
                    isDesc: false,
                    hasDropdown: true,
                    style: "width: 200px;",
                    options: BREEDER_STATUS_LIST,
                },
                { name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
            ],
            breederStatus: true,
            desc: true,
        };
    },
    created() {
        this.getTableContent(false, this.page, this.limit, this.sortBy, true);
    },
    activated() {
        // this lifecycle method will only be called for components under keep-alive
        this.getTableContent();
	},
    methods: {
        statusClass(status) {
            const { DECLINED } = BREEDER_STATUS;
        
            switch (status) {
                case "ACTIVE":
                    return "status--active";
                case "DEACTIVATED":
                    return "status--deactivated";
                case "FOR REACTIVATION":
                    return "status--for-reactivation";
                case DECLINED:
                case "DELETED":
                    return "status--declined";
                default:
                    return "";
            }
        },
        statusLabel(status) {
            const { DECLINED } = BREEDER_STATUS;
        
            switch (status) {
                case "ACTIVE":
                    return "Active";
                case "DELETED":
                    return "Deleted";
                case "DEACTIVATED":
                    return "Deactivated";
                case "FOR REACTIVATION":
                    return "For Reactivation";
                case DECLINED:
                    return "Declined";
                default:
                    return "";
            }
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
            this.getBreedersList({ page, limit, sortBy, desc });
        },
        getBreedersList(queryParams) {
            // search filters
            const { f_companyName, f_name, f_email, f_mobileNumber, f_state, f_verified, f_status } = this.columnsFilter;
            if (f_companyName) {
                queryParams["f_companyName"] = f_companyName;
            }

            if (f_name) {
                queryParams["f_name"] = f_name;
            }

            if (f_email) {
                queryParams["f_email"] = f_email;
            }

            if (f_mobileNumber) {
                queryParams["f_mobileNumber"] = f_mobileNumber;
            }

            if (f_state) {
                queryParams["f_state"] = f_state;
            }

            if (f_verified != null) {
                queryParams["f_verified"] = f_verified;
            }

            if (f_status != null) {
                queryParams["f_status"] = f_status;
            }

            this.isAPILoading = true;
            breederService
                .getBreedersList(queryParams)
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.tableContent = {
                            tableData: res.data.data.map((dt) => {
                                return {
                                    ...dt,
                                    state: STATES[dt.state],
                                    status: BREEDER_STATUS[dt.status],
                                };
                            }),
                            paginationData: res.data.pagination,
                        };
                    } else {
                        this.showAPIErrorToast("Unable to fetch breeders list.", res);
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                })
                .finally(() => {
                    this.isAPILoading = false;
                });
        },
        hasProductImage(productImage) {
            let image = require("@/assets/images/temporary/product-image.png");

            if (productImage) {
                image = productImage;
            }

            return image;
        },
        
        deleteBreeder(breeder) {
			const { name, id } = breeder;
			// show modal confirmation
			this.$swal({
				title: `Are you sure you want to delete ${name}?`,
				text: `You won't be able to revert this action.`,
				confirmButtonText: 'Delete',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#dd3333 !important',
				reverseButtons: true,
				showCloseButton: true
			})
			.then(result => {
				if (result.value) {
                    // API call for delete
					breederService.deleteBreeder(id).then(res => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast('Deleted!', `${name} has been deleted!`);
							// refresh table with filter
							this.getTableContent();
						} else {
							this.showAPIErrorToast(`Unable to delete ${name}`, res);
						}
					});
				}
			});
		},

        showHomeComingSoonAlert() {
			this.$swal({
				imageHeight: '170px',
				imageUrl: `${require('@/assets/images/_shared/coming-soon.png')}`,
				imageAlt: 'Coming Soon Dog',
				title: 'Coming Soon!',
				text: `This feature is under development.`,
				confirmButtonColor: '#4B8BFF',
				confirmButtonText: 'Got it'
			});
		}

    },
    // third party libraries
};
